import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { isValidGuid } from '@core/validation/util/regex-validator';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ScreeningService } from 'src/app/screening/services/screening.service';
import { InstallationInfoResponse } from '../models/installation-info-response.interface';

@Injectable({
  providedIn: 'root',
})
export class InstallationInfoRouteResolverService {
  private screeningService = inject(ScreeningService);

  resolve(
    route: ActivatedRouteSnapshot
  ): InstallationInfoResponse | Observable<InstallationInfoResponse> | Promise<InstallationInfoResponse> {
    const id: number = +route.paramMap.get('id');
    const identifier = route.paramMap.get('identifier');

    let isEdit: boolean;

    if (identifier) {
      isEdit = false;
      if (isValidGuid(identifier)) {
        return this.screeningService.verifyGuid(identifier).pipe(
          map(
            result =>
              ({
                info: {
                  ...result,
                  id: null,
                  identifier,
                  customerType: result.customerType,
                  screeningAnswers: null,
                  electricalPanelFileReferences: result.electricalPanelFileReferences,
                  wantedChargingStationLocationFileReferences: result.wantedChargingStationLocationFileReferences,
                },
                isEdit: isEdit,
              }) as InstallationInfoResponse
          ),
          catchError(() => {
            return of({ info: null, isEdit: isEdit }) as Observable<InstallationInfoResponse>;
          })
        );
      } else {
        return of({ info: null, isEdit: isEdit }) as Observable<InstallationInfoResponse>;
      }
    } else {
      isEdit = true;
      return this.screeningService.getScreeningAnswersForEdit(id).pipe(
        map(result => ({
          info: {
            identifier: result.identifier,
            id: id,
            customerType: result.customerType,
            screeningAnswers: result,
            electricalPanelFileReferences: result.electricalPanelFileReferences,
            wantedChargingStationLocationFileReferences: result.wantedChargingStationLocationFileReferences,
          },
          isEdit: isEdit,
        })),
        catchError(() => {
          return of({ info: null, isEdit: isEdit }) as Observable<InstallationInfoResponse>;
        })
      );
    }
  }
}
